import { combineReducers } from 'redux';
import list from './list';
import show from './show';
import forSelect from './forSelect';
import updateTags from "./updateTags";

export default combineReducers({ list, show, forSelect, updateTags });
